import styled from "styled-components";
import { GatsbyImage } from "gatsby-plugin-image";

const Footer = styled.footer`
  min-height: 300px;
`;

const FooterCertContainer = styled.div`
  background: rgba(255,255,255,.2);
    border-radius: .25rem;

    img {
        max-width: 45px;
        max-height: 45px;
        image-rendering: -moz-crisp-edges;
        image-rendering:   -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
        margin-right: 10px;
    }
    p {
        display: block;
    }
    b {
        display: block;
    }
`;

const FooterCertImage = styled(GatsbyImage)`
    width: 40px;
    height: 40px;
    object-fit: contain;
`;

const S = {
  Footer,
  FooterCertContainer,
  FooterCertImage
};

export default S;
